import React from 'react';
import classNames from 'classnames';
import GameDefault from '@/pages/home/assets/img/common/game-default.svg';
import mobileGameDefaultIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg';
import BasicImage from '@home/components/BasicImage';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import CommonBubble from '@home/components/CommonBubble';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';

export const getWeekRender = (item: any) => {
  const { data = [], valueFormatRule, percentFormatRule, dateFormatRule = 'day' } = item || {};
  return (
    <div className={'dbd-studio-home-kpi-table-week-render'}>
      {data?.map((item: any, index: number) => {
        const { color, value, kpi, noProgress } = item || {};

        if (noProgress) {
          return null;
        }

        let percent;
        let valuePercent;
        let kpiPerercent;

        // 没有值/kpi/kpi是0无法计算百分比
        if (!kpi || !value || Number(kpi) === 0) {
          percent = '-';
          valuePercent = '0';
          kpiPerercent = '0';
        } else {
          percent = dataFormat({
            value: Number(value) / Number(kpi),
            formatRule: percentFormatRule,
          });
          // 进度条总比例要比value和kpi大一点
          const maxValue = (Number(value) > Number(kpi) ? Number(value) : Number(kpi)) * 1.1;
          valuePercent = `${(Number(value) / maxValue) * 100 || 0}%`;
          kpiPerercent = `${(Number(kpi) / maxValue) * 100 || 0}%`;
        }

        return (
          <div
            key={index}
            className="dbd-studio-home-kpi-table-week-progress-content"
          >
            <div className="dbd-studio-home-kpi-table-week-progress">
              <div
                className="dbd-studio-home-kpi-table-week-progress-percent"
                style={{ backgroundColor: color, width: valuePercent }}
              ></div>
              {value && kpi && (
                <div
                  className="dbd-studio-home-kpi-table-week-progress-kpi"
                  style={{ left: kpiPerercent }}
                ></div>
              )}
            </div>
            <div className={classNames("dbd-studio-home-kpi-table-week-value", { 'dbd-studio-home-kpi-table-week-value-empty': !value })} >
              ({dataFormat({ value, formatRule: valueFormatRule })})
            </div>
            <div className="dbd-studio-home-kpi-table-week-percent">
              {percent}
            </div>
          </div>
        );
      })}
      <div className="dbd-studio-home-kpi-table-week-progress-legend-content">
        {data?.map((item: any) => {
          const { name, color, startDate, endDate, noProgress } = item || {};
          const startTime = dateTimeFormat(startDate, dateFormatRule);
          const endTime = dateTimeFormat(endDate, dateFormatRule);
          return (
            <CommonBubble key={name} content={noProgress ? null : `${startTime} ~ ${endTime}`}>
              <div
                key={name}
                className="dbd-studio-home-kpi-table-week-progress-legend"
              >
                <div
                  className="dbd-studio-home-kpi-table-week-progress-legend-color"
                  style={{ backgroundColor: color }}
                ></div>
                <div className="dbd-studio-home-kpi-table-week-progress-legend-name">
                  {name}
                </div>
              </div>
            </CommonBubble>
          );
        })}
      </div>
    </div>
  );
};

/**
 * 渲染完成度进度条组件
 * @param item - 包含渲染所需数据的对象
 * @param item.className - 自定义样式类名
 * @param item.value - 完成度数值(0-1之间)
 * @param item.formatRule - 数值格式化规则
 * @returns 返回包含进度条和格式化数值的 React 组件
 */
export const getCompletionRender = (item: any) => {
  const { className, value, formatRule } = item || {};
  const maxValue = Number(value) * 100 > 100 ? 100 : Number(value) * 100;
  return (
    <div
      className={classNames(
        className,
        'dbd-studio-home-kpi-table-completion-render',
      )}
    >
      <div className="dbd-studio-home-kpi-table-week-value">
        {dataFormat({ value, formatRule })}
      </div>
      <div className="dbd-studio-home-kpi-table-completion-progress">
        <div
          className="dbd-studio-home-kpi-table-week-progress-percent"
          style={{ width: `${maxValue || 0}%` }}
        ></div>
      </div>
    </div>
  );
};

/**
 * 渲染游戏卡片组件
 * @param item - 游戏信息对象
 * @param item.className - 自定义类名
 * @param item.name - 游戏名称
 * @param item.img - 游戏图片地址，默认为空字符串
 * @param item.isPc - 是否为PC端，默认为true
 */
export const getGameRender = (item: any) => {
  const { className, name, img = '', isPc = true } = item || {};
  return (
    <div
      className={classNames(className, 'dbd-studio-home-kpi-table-game-render')}
    >
      <div className="dbd-studio-home-kpi-table-game-img">
        <BasicImage
          src={img}
          alt=""
          errorSrc={isPc ? GameDefault : mobileGameDefaultIcon}
        />
      </div>
      <div className="dbd-studio-home-kpi-table-game-name">{name}</div>
    </div>
  );
};
